// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  PagesContainer,
  Page,
  ArrowIcon,
} from 'components/grid/list/components/pagination/style';
import { Row } from 'components/layout';
import { noop, range } from 'lodash';

class PagesList extends Component<any> {
  static propTypes = {
    onPageChange: PropTypes.func,
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    count: PropTypes.number,
    size: PropTypes.string,
    render: PropTypes.func,
  };

  static defaultProps = {
    render: undefined,
    onPageChange: noop,
    totalPages: 0,
    currentPage: 1,
    count: 0,
    size: 'large',
  };

  pageChanged = (page) => () => {
    const { currentPage, onPageChange } = this.props;
    if (page !== currentPage) {
      onPageChange(page);
    }
  };

  renderPages = () => {
    const { totalPages, size } = this.props;
    const currentPage = parseInt(this.props.currentPage, 10);
    const showPages = size === 'large' ? 9 : 7;
    const padding = size === 'large' ? 2 : 1;

    let pages = [];

    if (totalPages <= showPages) {
      pages = totalPages > 1 ? range(1, totalPages + 1) : [1];
    } else {
      const showHighDots = currentPage + (padding + 2) < totalPages;
      const showLowDots = currentPage - padding > 3;

      if (showLowDots && showHighDots) {
        pages = [1, null];
        let index = currentPage - padding;
        for (index; index <= currentPage + padding; index++) {
          pages.push(index);
        }
        pages = [...pages, null, totalPages];
      } else if (showLowDots) {
        pages = [1, null, ...range(totalPages - showPages + 3, totalPages + 1)];
      } else if (showHighDots) {
        pages = [...range(1, showPages - 1), null, totalPages];
      }
    }

    return pages.map((page) => {
      const hasPage = page !== null;

      const props = {
        ...(hasPage ? { onClick: this.pageChanged(page) } : {}),
      };

      return (
        <Page
          key={page}
          current={this.props.currentPage === page}
          data-type={`page-${page}`}
          {...props}>
          {page || '...'}
        </Page>
      );
    });
  };

  render() {
    const { render, currentPage, count, totalPages } = this.props;

    if (render) {
      return render.call(this);
    }

    if (!count) {
      return null;
    }

    const cp = parseInt(currentPage, 10);
    const previousPage = cp === 1 ? noop : this.pageChanged(cp - 1);
    const nextPage = cp === totalPages ? noop : this.pageChanged(cp + 1);

    if (count && totalPages > 1) {
      return (
        <PagesContainer data-type="pages-list">
          <Row>
            <ArrowIcon onClick={previousPage} data-type="prev-page-icon" />
            {this.renderPages()}
            <ArrowIcon onClick={nextPage} data-type="next-page-icon" $right />
          </Row>
        </PagesContainer>
      );
    }

    return null;
  }
}

export default PagesList;
